export interface Chip {
  id: string;
  label: string;
  count?: number;
  live?: boolean;
}

interface Props {
  items: (Chip | string)[];
  active?: string;
  onSelect?: (id: string) => void;
  showCount?: boolean;
}

export function MaChipRow({ items, active, onSelect, showCount = false }: Props) {
  return (
    <div
      className="ma-h-scroll"
      style={{
        display: "flex", gap: 8, overflowX: "auto",
        padding: "8px 16px",
      }}
    >
      {items.map((it) => {
        const id = typeof it === "string" ? it : it.id;
        const label = typeof it === "string" ? it : it.label;
        const count = typeof it === "object" ? it.count : undefined;
        const live = typeof it === "object" ? it.live : false;
        const on = id === active;
        return (
          <button
            key={id}
            onClick={() => onSelect && onSelect(id)}
            className={on ? "ma-chip ma-chip-solid" : "ma-chip"}
            style={{
              cursor: "pointer", flexShrink: 0,
              background: live ? "var(--ma-brick)" : on ? "var(--ma-ink)" : "var(--ma-cream)",
              color: on || live ? "var(--ma-paper)" : "var(--ma-ink)",
              borderColor: "var(--ma-ink)",
            }}
          >
            {live && <span style={{ width: 6, height: 6, borderRadius: "50%", background: "var(--ma-paper)" }} />}
            {label}
            {showCount && count != null && <span style={{ opacity: 0.65, marginLeft: 4 }}>{count}</span>}
          </button>
        );
      })}
    </div>
  );
}
